export default __webpack_public_path__ + "static/media/prometheus-tool.418065c6.jpg";